import { Sites } from '@ps/platform-message-framework/common/Sites';
import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { select } from '@swf/core/store';

import {
  TXTWCL_To_find_out_moreX_visit_our_Xa_ELL,
  TXTWCL_We_use_electronic_identity_ver_ELL
} from './HelpSectionVerification.messages.json';

const accountValidationLicense = [
  Sites.CA_ON,
  Sites.ROM,
  Sites.UK,
  Sites.FRA,
  Sites.POR,
  Sites.SPA,
  Sites.BEL,
  Sites.DE
];

const HelpSectionVerification: React.FC = () => {
  const site = useSelector(select.cms.getSiteId);
  const resolverTagContent = accountValidationLicense.includes(site)
    ? ResolverTag.AccountValidation
    : ResolverTag.CustomerVerificationProcess;

  return (
    <>
      <Translation {...TXTWCL_We_use_electronic_identity_ver_ELL} />{' '}
      <Translation
        values={{
          a: (msg: React.ReactNode) => (
            <ResolverLink resolverTag={resolverTagContent}>{msg}</ResolverLink>
          )
        }}
        {...TXTWCL_To_find_out_moreX_visit_our_Xa_ELL}
      />
    </>
  );
};

export default HelpSectionVerification;
